import { GET, GET_EDIT_MANAGEMENT_PAGE } from '../../../../services';
import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'preact/hooks';

export const useGetEditManagement = ({ mapProductId, reset }) => {
  const [data, setData] = useState([]);
  const { isPending, mutate } = useMutation({
    mutationFn: async () => {
      const response = await GET(GET_EDIT_MANAGEMENT_PAGE(mapProductId));
      return response.result.item;
    },
    onSuccess: (result) => {
      setData(result);
      reset({
        ...result,
        productImageUrl: [{ uid: result?.productImageUrl, url: result?.productImageUrl }],
      });
    },
  });

  useEffect(() => {
    if (mapProductId) {
      mutate();
    }
  }, [mapProductId]);

  return { dataSource: data, setData, onSearch: mutate, loading: isPending };
};
